import * as React from "react";
import { useSelector } from "react-redux";
import { RouteComponentProps } from "react-router";
import { Redirect, Route, Switch } from "react-router-dom";

import { isInIframe } from "helpers/app";
import { IWithBreakpointsProps, withBreakpoints } from "helpers/withBreakpoints";
import { useIframeNavigationSync } from "hooks/use-iframe-navigation-sync";
import { useIframeSendAppDataLoadedMessage } from "hooks/use-iframe-send-app-data-loaded-message";
import { selectIsAdmin } from "store/entities/agents";

import { SettingsRoutes } from "../constants";

import { TemplateComposer } from "./TemplateComposer";
import { TemplatesList } from "./TemplatesList";
import { NoMobile } from "./components/NoMoblieScreen";

const EmailTemplate: React.FC<RouteComponentProps & IWithBreakpointsProps> = ({ isDesktop }) => {
  const isAdmin = useSelector(selectIsAdmin);
  const isEmbeddedInIframe = isInIframe();
  const shouldDisplayPage = isDesktop || isEmbeddedInIframe;

  useIframeNavigationSync();
  useIframeSendAppDataLoadedMessage();

  return (
    <Switch>
      {isAdmin && shouldDisplayPage && (
        <Route path={`${SettingsRoutes.EmailTemplates}/add`} component={TemplateComposer} />
      )}
      {isAdmin && shouldDisplayPage && (
        <Route path={`${SettingsRoutes.EmailTemplates}/edit/:id`} component={TemplateComposer} />
      )}
      {isAdmin && shouldDisplayPage && (
        <Route path={`${SettingsRoutes.EmailTemplates}/duplicate/:id`} component={TemplateComposer} />
      )}
      {shouldDisplayPage && <Route path={SettingsRoutes.EmailTemplates} component={TemplatesList} />}
      {!shouldDisplayPage && <Route path={SettingsRoutes.EmailTemplates} component={NoMobile} />}
      <Redirect to={SettingsRoutes.EmailTemplates} />
    </Switch>
  );
};

export default withBreakpoints(EmailTemplate);
